/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * Audius API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { RemixContestUpdateNotificationActionData } from './RemixContestUpdateNotificationActionData';
import {
    RemixContestUpdateNotificationActionDataFromJSON,
    RemixContestUpdateNotificationActionDataFromJSONTyped,
    RemixContestUpdateNotificationActionDataToJSON,
} from './RemixContestUpdateNotificationActionData';

/**
 * 
 * @export
 * @interface RemixContestUpdateNotificationAction
 */
export interface RemixContestUpdateNotificationAction {
    /**
     * 
     * @type {string}
     * @memberof RemixContestUpdateNotificationAction
     */
    specifier: string;
    /**
     * 
     * @type {string}
     * @memberof RemixContestUpdateNotificationAction
     */
    type: string;
    /**
     * 
     * @type {number}
     * @memberof RemixContestUpdateNotificationAction
     */
    timestamp: number;
    /**
     * 
     * @type {RemixContestUpdateNotificationActionData}
     * @memberof RemixContestUpdateNotificationAction
     */
    data: RemixContestUpdateNotificationActionData;
}

/**
 * Check if a given object implements the RemixContestUpdateNotificationAction interface.
 */
export function instanceOfRemixContestUpdateNotificationAction(value: object): value is RemixContestUpdateNotificationAction {
    let isInstance = true;
    isInstance = isInstance && "specifier" in value && value["specifier"] !== undefined;
    isInstance = isInstance && "type" in value && value["type"] !== undefined;
    isInstance = isInstance && "timestamp" in value && value["timestamp"] !== undefined;
    isInstance = isInstance && "data" in value && value["data"] !== undefined;

    return isInstance;
}

export function RemixContestUpdateNotificationActionFromJSON(json: any): RemixContestUpdateNotificationAction {
    return RemixContestUpdateNotificationActionFromJSONTyped(json, false);
}

export function RemixContestUpdateNotificationActionFromJSONTyped(json: any, ignoreDiscriminator: boolean): RemixContestUpdateNotificationAction {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'specifier': json['specifier'],
        'type': json['type'],
        'timestamp': json['timestamp'],
        'data': RemixContestUpdateNotificationActionDataFromJSON(json['data']),
    };
}

export function RemixContestUpdateNotificationActionToJSON(value?: RemixContestUpdateNotificationAction | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'specifier': value.specifier,
        'type': value.type,
        'timestamp': value.timestamp,
        'data': RemixContestUpdateNotificationActionDataToJSON(value.data),
    };
}

